import React from 'react';
import Button from 'components/Button';
import {useToggle} from 'hooks/useToggle';
import Card from 'pages/dashboard/components/_Card';
import {useScreens} from 'pages/dashboard/components/FirstLook/useScreens';

import {FirstLook} from '..';

import BG1 from './svgs/bg1.inline.svg';
import BG2 from './svgs/bg2.inline.svg';
import BG3 from './svgs/bg3.inline.svg';
import ExpandIcon from './svgs/expand.inline.svg';

import * as styles from './styles.module.scss';

export const FirstLookCard = () => {
	const {open, toggle} = useToggle(false);
	const screens = useScreens();

	if (screens.length === 0) {
		return null;
	}

	// Wrap all three card backgrounds, select using CSS
	const bg = (
		<div className={styles.bg}>
			<BG1 className={styles.bg1} />
			<BG2 className={styles.bg2} />
			<BG3 className={styles.bg3} />
		</div>
	);

	return (
		<Card bg={{component: bg}} className={styles.card} shadow>
			<div className={styles.text}>
				<h1>Your <em>first look</em> is ready!</h1>
				<p>Discover your scan's surprises.</p>
			</div>
			<Button variant='light' onClick={toggle}>
				<span>
					Dive in <ExpandIcon />
				</span>
			</Button>
			{open && <FirstLook screens={screens} onClose={toggle} />}
		</Card>
	);
};
